import React, { useCallback } from 'react'
import { Button } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { useHistory } from 'react-router-dom'

const useStyles = makeStyles((theme: Theme) => ({
  button: {
    width: ({ width }: propTypes) => width,
    marginTop: ({ mt }: propTypes) => mt,
    marginBottom: ({ mb }: propTypes) => mb,
    padding: '16px 0',
    borderRadius: 28,
    fontSize: 14,
    fontWeight: 'bold',
    letterSpacing: 1,
    color: theme.palette.primary.dark,
    background: theme.palette.secondary.light,
    '&:hover': {
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.secondary.main,
    },
    '&.MuiButton-contained.Mui-disabled': {
      color: theme.palette.primary.dark,
      backgroundColor: theme.palette.secondary.light,
      opacity: 0.6,
    },
  },
}))

type propTypes = {
  width: number | string
  text: string
  mt?: number | string
  mb?: number | string
  type?: string
  href?: string
  disabled?: boolean
  noHistory?: boolean
}

export const GreenButton: React.FC<propTypes> = ({ text, width, mt, mb, type, href, disabled, noHistory }) => {
  const classes = useStyles({ text, width, mt, mb, type, href })
  const history = useHistory()

  const goTo = useCallback(() => {
    if (noHistory) {
      window.location.replace(`${href}`)
    } else {
      history.push(`${href}`)
    }
  }, [history, href, noHistory])

  return (
    <Button
      disabled={disabled}
      variant="contained"
      type="submit"
      onClick={href ? goTo : undefined}
      className={classes.button}
    >
      <span>{text}</span>
    </Button>
  )
}
